// required field error
export const REQUIRED = "This field is required.";
export const EMAIL_REQUIRED = "Email is required";
export const PASSWORD_REQUIRED = "Password is required";
export const NEW_PASSWORD_REQUIRED = "New Password is required";
export const CONFIRM_PASSWORD_REQUIRED = "Confirm Password is required";
export const MOBILE_NUMBER_REQUIRED = "Mobile number is required";
export const COUNTRY_CODE_REQUIRED = "Please select your country code";
export const NAME_REQUIRED = "Name is required";
export const TNC_REQUIRED = "Terms of Services check is required";

// validation error
export const VALID_EMAIL = "Enter a valid email address";
export const VALID_PASSWORD =
  "It must have atleast 8 characters, 1 Uppercase, 1 Lowercase, 1 digit & 1 special character";
export const VALID_CONFIRM_PASSWORD = "Passwords must match";
export const VALID_NUMBER = "Enter a valid mobile number";
export const NAME_DIGIT_CHECK = "Name shouldn't contain digits";
